module.exports = __webpack_public_path__ + "static/img/img.335bacbd.gif";